import {
    ApiClientFactory
} from '../ApiClientFactory';

import {
    API_V4_URL,
    API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const GroupsClient = {
    /**
     *
     * Returns group
     */
    getGroupUsers(groupId) {
        return clientFactory.get(API_URL + 'groups/' + groupId + '/users');
    },
    getGroups(params = {}) {
        return clientFactory.get(API_V4_URL + 'groups/', {
            params: params
        });
    },
    get(conf = {}) {
        return clientFactory.get('/groups', conf);
    },


};
